import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const DataPoints = () => {
  const dataPoints = useSelector((state) => state.totalVisits.dataPoints);

  return (
    <div
      data-testid="scorecards"
      className="scorecards"
      style={{ marginTop: "110px", justifyContent: "initial", flexWrap: "wrap" }}
    >
      {dataPoints.map(({ label, value, url }) => (
        <div key={label} style={{ width: "33%", marginBottom: "20px" }}>
          <DataDisplay value={value} label={label} url={url} disableAnimation />
        </div>
      ))}
    </div>
  );
};
